import { isEmpty } from 'lodash';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { MEDIA_QUERIES } from '@sm360/widget-commons-general';
import { InputDropDown } from '@sm360/widget-commons-forms';
import { ModelYear } from '@sm360/widget-commons-vehicle';

import 'build-and-quote/components/ModelTrims/modelTrims.scss';
import 'build-and-quote/components/ModelTrims/modelTrimSelection.scss';

const CabSizes = ({
    availableBoxSizes,
    availableCabSizes,
    onBoxSelect,
    onCabSelect,
    selectedBoxSize,
    selectedCabSize,
}) => {
    if (isEmpty(availableCabSizes)) {
        return null;
    }
    const options = availableCabSizes.map((cabSize) => {
        return {
            ...cabSize.toObject(),
            label: cabSize.description,
            value: cabSize.selectionCode,
        };
    });

    const boxOptions = availableBoxSizes.map((boxSize) => {
        return {
            ...boxSize.toObject(),
            label: boxSize.description,
            value: boxSize.selectionCode,
        };
    });

    const availableCabSizesSection = availableCabSizes ? (
        options.map((cabSize) => {
            const availableCabSizesSectionClasses = ['style-trim__lists__item'];
            if (cabSize.selected) {
                availableCabSizesSectionClasses.push('selected has-price-background');
            }
            if (!cabSize.enabled) {
                availableCabSizesSectionClasses.push('disabled');
            }
            const iconClass = `icon-Cab-${cabSize.code}`;
            return (
                <li key={cabSize.selectionCode} className={availableCabSizesSectionClasses.join(' ')}>
                    <button className="style-trim-btn" onClick={() => cabSize.enabled && onCabSelect(cabSize)}>
                        <icon className={iconClass} />
                        {cabSize.label}
                    </button>
                </li>
            );
        })
    ) : (
        <li />
    );

    const availableBoxSizesSection = availableBoxSizes ? (
        boxOptions.map((boxSize) => {
            const availableBoxSizesSectionClasses = ['style-trim__lists__item'];
            if (boxSize.selected) {
                availableBoxSizesSectionClasses.push('selected has-price-background');
            }
            if (!boxSize.enabled) {
                availableBoxSizesSectionClasses.push('disabled');
            }
            const iconClass = `icon-Box-${boxSize.code}`;
            return (
                <li key={boxSize.selectionCode} className={availableBoxSizesSectionClasses.join(' ')}>
                    <button className="style-trim-btn" onClick={() => boxSize.enabled && onBoxSelect(boxSize)}>
                        <icon className={iconClass} />
                        {boxSize.label}
                    </button>
                </li>
            );
        })
    ) : (
        <li />
    );
    return (
        <div className="bloc-container">
            <div className="bloc-container-wrapper">
                <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>
                    <div className="style-trim">
                        <ul className="style-trim__lists">{availableCabSizesSection}</ul>
                        <ul className="style-trim__lists">{availableBoxSizesSection}</ul>
                    </div>
                </MediaQuery>
                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                    <InputDropDown
                        name="cabsize"
                        options={options}
                        placeholder={LocaleService.t('MODELTRIM_CABSIZE.LABEL')}
                        value={selectedCabSize && selectedCabSize.selectionCode}
                        isRequired
                        valueChange={(trim) => onCabSelect(trim)}
                    />
                    <InputDropDown
                        name="boxsize"
                        options={boxOptions.filter(({ enabled }) => enabled)}
                        placeholder={LocaleService.t('MODELTRIM_BOXSIZE.LABEL')}
                        value={selectedBoxSize && selectedBoxSize.selectionCode}
                        isRequired
                        valueChange={(trim) => onBoxSelect(trim)}
                    />
                </MediaQuery>
            </div>
        </div>
    );
};

CabSizes.propTypes = {
    availableBoxSizes: PropTypes.arrayOf(ModelYear.BoxSizeModel).isRequired,
    availableCabSizes: PropTypes.arrayOf(ModelYear.CabSizeModel).isRequired,
    onBoxSelect: PropTypes.func.isRequired,
    onCabSelect: PropTypes.func.isRequired,
    selectedBoxSize: PropTypes.instanceOf(ModelYear.BoxSizeModel).isRequired,
    selectedCabSize: PropTypes.instanceOf(ModelYear.CabSizeModel).isRequired,
};

CabSizes.displayName = 'CabSizes';

export default CabSizes;
